export const mapByKey = <T, K extends keyof T & string>(list: T[], key: K) =>
  list.reduce(
    (acc, item) => {
      acc[item[key] as string] = item;
      return acc;
    },
    {} as Record<string, T>,
  );
